import { GridCellProps } from '@progress/kendo-react-grid';
import { useContext } from 'react';
import { EditCellContext } from 'src/contexts/EditCellContext';
import GridCellBase from '../GridCellBase';

const PercentReceivedCell = (props: GridCellProps) => {
  const [cellClick] = useContext(EditCellContext);
  const field = props?.field || '';
  const value = props?.dataItem?.[field];
  const dataItem = props?.dataItem;
  const { onPercentReceivedDollarClick, onPercentReceivedQtyClick } = cellClick?.(null);
  const onCellClick =
    field === 'percentRecvByDollar' ? onPercentReceivedDollarClick : onPercentReceivedQtyClick;

  return (
    <GridCellBase {...props} title={value} rowSelectionEnabled={true}>
      <span>
        {value === 'N/A' ? value : `${value}%`}
        <span
          onClick={(e) => {
            onCellClick(dataItem);
            e.stopPropagation();
          }}
          className="k-icon k-i-info cursor-pointer"
          title="View Details"
        />
      </span>
    </GridCellBase>
  );
};

export default PercentReceivedCell;
